import { io } from "socket.io-client";
import authService from "./AuthService";
import jwt_decode from "jwt-decode";
import { WEBSOCKETS_URL } from "configs/AppConfig";

class WebsocketService {
  constructor() {
    this.loadInstance().catch(console.debug);
  }

  loadInstance = async () => {
    let token = "Bearer " + authService.getToken();
    let userId = jwt_decode(token)?.user_id;

    this.userId = userId;
    this.instance = io(WEBSOCKETS_URL, {
      forceNew: true,
      extraHeaders: {
        Authorization: token,
        UserId: userId,
      },
    });

    this.instance.on("connect", () => {
      this.instance.emit("join", `user-${userId}`);
    });
  };

  dropInstanceOfOtherUser = (token) => {
    if (!this.instance) return;
    let userId;
    try {
      userId = jwt_decode(token)?.user_id;
    } catch (error) {
      return;
    }
    if (userId === this.userId) return;
    this.instance.disconnect();
    this.instance = undefined;
    this.userId = undefined;
  };

  listenAndExecuteEvent = (eventName, callBack) => {
    let token = authService.getToken();
    if (token) this.dropInstanceOfOtherUser(token);
    if (token && !this.instance) this.loadInstance().catch(console.debug);
    if (token && this.instance) this.instance.on(eventName, callBack);
  };

  removeEventListener = (eventName, callBack) => {
    if (this.instance) this.instance.off(eventName, callBack);
  };
}

const websocketService = new WebsocketService();
export default websocketService;
